import propTypes from 'prop-types';
import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { get } from '../../server/actions';
import { BASE_URL } from '../../server/constants';
import { _addNotificationError, emailPattern } from '../../server/util';
import Fingerprint from 'fingerprintjs';
class ParentOtherLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            logoUrl: '',
            schoolName: '',
            parentEmail: '',
            deviceId: '',
            redirectURL: '',
            parentRegMsg: '',
            isParentError: false

        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        const { domain } = this.props.match.params;
        let fp = new Fingerprint({
            canvas: true,
            ie_activex: true,
            screen_resolution: true
        });
        this.setState({ deviceId: fp.get() });
        this.getSchoolDetails(domain);

    }
    getSchoolDetails = (domain) => {
        this.setState({ loading: true });
        get(`/schoolInfoByDomain/${domain}`, false)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then((data) => {
                const { logoLink, schoolName } = data || {};
                this.setState({ logoUrl: logoLink, schoolName: schoolName, loading: false })
            }).catch(
                (error) => {
                    _addNotificationError('Invalid URL. Please contact your school administrator.', this);
                    this.setState({ loading: false });
                    this.context.router.history.push('/404')
                    console.log('Get School data response', error)
                }
            );
    }
    handleParentEmailChanged(event) {
        this.setState({ parentEmail: event.target.value });
    }
    validateEmail = (mail) => {
        if (emailPattern.test(mail)) {
            return (true)
        }
        _addNotificationError("You have entered an invalid email address!", this)
        return (false)
    }
    validateParentEmail = (event) => {
        event.preventDefault();
        if (!this.validateEmail(this.state.parentEmail)) {
            return false;
        }
        this.setState({ loading: true })

        get(`/validateParentAndDevice?userEmailId=${this.state.parentEmail}&deviceId=${this.state.deviceId}`, false).then((response) => {
            if (!response.ok) {
                if (response.status == 417) {
                    return response.json();
                }
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            if (data.statusCode == 417) {
                this.setState({ parentRegMsg: data.statusMessage, isParentError: true, loading: false });
            } else {
                const redirectURL = `${window.location.origin}/activateParentAccount?parentId=${this.state.parentEmail}&token=${data.token}`;
                this.setState({ redirectURL: redirectURL, loading: false, isParentError: false, parentRegMsg: '' });
            }
        }).catch(
            (error) => {
                this.setState({ parentRegMsg: error })
                // this.setState({ parentRegMsg:'Invalid parent email id.'});
                this.setState({ isParentError: true, loading: false });
                // _addNotificationError('Invlid service', this)
                console.log(' response', error)
            }
        );
    }
    selfRegParent = (event) => {
        event.preventDefault();
        get('/selfRegParent?emailId=' + this.state.parentEmail, false).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            // this.setState({ parentRegMsg:'Request submitted successfully. Activation link will receive to your registered email id.'});
            // this.setState({isParentError:false});
        }).catch(
            (error) => {
                // this.setState({ parentRegMsg:'Invalid parent email id.'});
                // this.setState({isParentError:true});
                // _addNotificationError('Invlid service', this)
                console.log(' response', error)
            }
        );
        this.setState({ parentRegMsg: 'Request submitted successfully. If your email id is registered, you will receive an access link soon.' });
        this.setState({ isParentError: false });
        event.preventDefault();
    }
    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                {/* <AppHeader/> */}
                <div>
                    <section className="mainContent full-width clearfix" style={{ padding: '0px' }}>
                        <div className='row' style={{ overflowY: 'scroll', overflowX: 'hidden', height: 'calc(100vh - 70px)' }}>
                            <div className='col-lg-7 col-md-6 col-sm-12 loginBackground'>
                            </div>
                            <div className='col-lg-5 col-md-6 col-sm-12'>
                                <div className='row'>
                                    <div className='col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1'>
                                        <div className='row'>
                                            {
                                                (this.state.logoUrl || '').length > 0 ?
                                                    <div className='col-md-12 text-center'>
                                                        <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '10px' }}>
                                                            <img className="super-admin-logo" src={this.state.logoUrl} alt="" />
                                                        </div>
                                                    </div> : <div className='sectionTitle text-center'>
                                                        <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '10px' }}>
                                                            <h2 style={{ fontSize: '30px' }}>{this.state.schoolName}</h2>
                                                        </div>
                                                    </div>
                                            }

                                            <div className='col-md-12'>
                                                <div className="panel panel-default formPanel">
                                                    <div className="panel-heading border-color-1" style={{
                                                        backgroundColor: '#ea7066'
                                                    }}>
                                                        {
                                                            this.state.redirectURL.length <= 0 ?
                                                                <h3 style={{ textTransform: "none" }} className="panel-title">Enter Registered Email Id</h3>
                                                                : <h3 style={{ textTransform: "none" }} className="panel-title">You are almost  there !! Click Below Link</h3>
                                                        }

                                                    </div>
                                                    <div className="panel-body">
                                                        {
                                                            this.state.redirectURL.length <= 0 ?
                                                                <form
                                                                    className="login-form ng-dirty ng-valid-parse ng-valid ng-valid-required"
                                                                    onSubmit={this.validateParentEmail}>
                                                                    <div className="form-group formField">
                                                                        <input
                                                                            className="form-control ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched"
                                                                            name="parent-id" type="email" autoComplete='off'
                                                                            placeholder="Email"
                                                                            value={this.state.parentEmail}
                                                                            onChange={this.handleParentEmailChanged.bind(this)}
                                                                        />
                                                                        <span
                                                                            className={this.state.isParentError ? 'color-3' : 'color-2'}>
                                                                            {this.state.parentRegMsg}
                                                                        </span>
                                                                    </div>

                                                                    <div className="form-group formField">
                                                                        <button type="submit" id="btnParentSubmit"
                                                                            name="btnParentSubmit"
                                                                            style={{ marginLeft: '0px' }}
                                                                            className="btn btn-primary btn-block bg-color-3 border-color-3">Login
                                                                        </button>
                                                                    </div>

                                                                </form> :
                                                                <div className="form-group formField">
                                                                    <button type="button" id="btngoDashboard"
                                                                        name="btngoDashboard"
                                                                        style={{ marginLeft: '0px' }}
                                                                        className="btn btn-primary btn-block bg-color-3 border-color-3" onClick={() => {
                                                                            window.location.href = this.state.redirectURL;
                                                                        }}>Go To Parent Dashboard
                                                                    </button>
                                                                </div>
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

ParentOtherLogin.contextTypes = {
    router: propTypes.object.isRequired
}

export default ParentOtherLogin;


// WEBPACK FOOTER //
// ./src/components/ParentOtherLogin/index.js